module.exports = __webpack_public_path__ + "img/Property 1=icon017.ddfe34d6.svg";